import React from 'react';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import App from "./App";
import GuestQrcodeComponent from "./components/GuestQrcodeComponent";
import GuestChangelangComponent from "./components/GuestChangelangComponent";
import MemberComponent from "./components/member/MemberComponent";
import LinkListComponent from "./components/member/LinkListComponent";
import DocComponent from "./components/member/DocComponent";
import ProfileComponent from "./components/member/ProfileComponent";
import DonateComponent from "./components/member/DonateComponent";
import LinkToComponent from "./components/LinkToComponent";

const MyRoute: React.FC = () => {
    return (
        <BrowserRouter>
            <Routes>
                <Route path="/" element={<App />} />
                <Route path="/qrcode" element={<GuestQrcodeComponent />} />
                <Route path="/changelang" element={<GuestChangelangComponent />} />
                <Route path="/member" element={<MemberComponent />} />
                <Route path="/member/linklist" element={<LinkListComponent />} />
                <Route path="/member/doc" element={<DocComponent />} />
                <Route path="/member/profile" element={<ProfileComponent />} />
                <Route path="/member/other" element={<DonateComponent />} />
                <Route path="*" element={<LinkToComponent />} />
            </Routes>
        </BrowserRouter>
    );
};

export default MyRoute;
